import { Action } from 'redux';

export const CREATE_SERVICIO_CLINICO_REQUEST = 'CREATE_SERVICIO_CLINICO_REQUEST';
export const CREATE_SERVICIO_CLINICO_SUCCESS = 'CREATE_SERVICIO_CLINICO_SUCCESS';
export const CREATE_SERVICIO_CLINICO_FAILURE = 'CREATE_SERVICIO_CLINICO_FAILURE';

export const FETCH_SERVICIOS_CLINICOS_REQUEST = 'FETCH_SERVICIOS_CLINICOS_REQUEST';
export const FETCH_SERVICIOS_CLINICOS_SUCCESS = 'FETCH_SERVICIOS_CLINICOS_SUCCESS';
export const FETCH_SERVICIOS_CLINICOS_FAILURE = 'FETCH_SERVICIOS_CLINICOS_FAILURE';

export const SET_SERVICIOS_CLINICOS_PAGE = 'SET_SERVICIOS_CLINICOS_PAGE';
export const SET_SERVICIOS_CLINICOS_LIMIT = 'SET_SERVICIOS_CLINICOS_LIMIT';

export const UPDATE_SERVICIO_CLINICO_REQUEST = 'UPDATE_SERVICIO_CLINICO_REQUEST';
export const UPDATE_SERVICIO_CLINICO_SUCCESS = 'UPDATE_SERVICIO_CLINICO_SUCCESS';
export const UPDATE_SERVICIO_CLINICO_FAILURE = 'UPDATE_SERVICIO_CLINICO_FAILURE';

export const DELETE_SERVICIO_CLINICO_REQUEST = 'DELETE_SERVICIO_CLINICO_REQUEST';
export const DELETE_SERVICIO_CLINICO_SUCCESS = 'DELETE_SERVICIO_CLINICO_SUCCESS';
export const DELETE_SERVICIO_CLINICO_FAILURE = 'DELETE_SERVICIO_CLINICO_FAILURE';

export interface CreateServicioClinicoRequestAction extends Action<typeof CREATE_SERVICIO_CLINICO_REQUEST> {
  type: typeof CREATE_SERVICIO_CLINICO_REQUEST;
}

export interface CreateServicioClinicoSuccessAction extends Action<typeof CREATE_SERVICIO_CLINICO_SUCCESS> {
  type: typeof CREATE_SERVICIO_CLINICO_SUCCESS;
  payload: any;
}

export interface CreateServicioClinicoFailureAction extends Action<typeof CREATE_SERVICIO_CLINICO_FAILURE> {
  type: typeof CREATE_SERVICIO_CLINICO_FAILURE;
  payload: string;
}

export interface FetchServiciosClinicosRequestAction extends Action<typeof FETCH_SERVICIOS_CLINICOS_REQUEST> {
  type: typeof FETCH_SERVICIOS_CLINICOS_REQUEST;
}

export interface FetchServiciosClinicosSuccessAction extends Action<typeof FETCH_SERVICIOS_CLINICOS_SUCCESS> {
  type: typeof FETCH_SERVICIOS_CLINICOS_SUCCESS;
  payload: {
    data: any[];
    meta: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export interface FetchServiciosClinicosFailureAction extends Action<typeof FETCH_SERVICIOS_CLINICOS_FAILURE> {
  type: typeof FETCH_SERVICIOS_CLINICOS_FAILURE;
  payload: string;
}

export interface SetServiciosClinicosPageAction extends Action<typeof SET_SERVICIOS_CLINICOS_PAGE> {
  type: typeof SET_SERVICIOS_CLINICOS_PAGE;
  payload: number;
}

export interface SetServiciosClinicosLimitAction extends Action<typeof SET_SERVICIOS_CLINICOS_LIMIT> {
  type: typeof SET_SERVICIOS_CLINICOS_LIMIT;
  payload: number;
}

export interface UpdateServicioClinicoRequestAction extends Action<typeof UPDATE_SERVICIO_CLINICO_REQUEST> {
  type: typeof UPDATE_SERVICIO_CLINICO_REQUEST;
}

export interface UpdateServicioClinicoSuccessAction extends Action<typeof UPDATE_SERVICIO_CLINICO_SUCCESS> {
  type: typeof UPDATE_SERVICIO_CLINICO_SUCCESS;
  payload: any;
}

export interface UpdateServicioClinicoFailureAction extends Action<typeof UPDATE_SERVICIO_CLINICO_FAILURE> {
  type: typeof UPDATE_SERVICIO_CLINICO_FAILURE;
  payload: string;
}

export interface DeleteServicioClinicoRequestAction extends Action<typeof DELETE_SERVICIO_CLINICO_REQUEST> {
  type: typeof DELETE_SERVICIO_CLINICO_REQUEST;
}

export interface DeleteServicioClinicoSuccessAction extends Action<typeof DELETE_SERVICIO_CLINICO_SUCCESS> {
  type: typeof DELETE_SERVICIO_CLINICO_SUCCESS;
  payload: string;
}

export interface DeleteServicioClinicoFailureAction extends Action<typeof DELETE_SERVICIO_CLINICO_FAILURE> {
  type: typeof DELETE_SERVICIO_CLINICO_FAILURE;
  payload: string;
}

export type ServiciosClinicosActionTypes =
  | CreateServicioClinicoRequestAction
  | CreateServicioClinicoSuccessAction
  | CreateServicioClinicoFailureAction
  | FetchServiciosClinicosRequestAction
  | FetchServiciosClinicosSuccessAction
  | FetchServiciosClinicosFailureAction
  | SetServiciosClinicosPageAction
  | SetServiciosClinicosLimitAction
  | UpdateServicioClinicoRequestAction
  | UpdateServicioClinicoSuccessAction
  | UpdateServicioClinicoFailureAction
  | DeleteServicioClinicoRequestAction
  | DeleteServicioClinicoSuccessAction
  | DeleteServicioClinicoFailureAction;